import { PublicClientApplication } from "@azure/msal-browser";

export const loginRequest = {
	scopes: ["openid", "profile"],
};

export const graphConfig = {
	graphMeEndpoint: "https://graph.microsoft.com/v1.0/me",
	graphMyPhotoEndpoint: "https://graph.microsoft.com/v1.0/me/photo/$value",
};

const configuration = {
	auth: {
		clientId: process.env.REACT_APP_MSAL_CLIENT_ID,
		authority: `https://login.microsoftonline.com/${process.env.REACT_APP_MSAL_TENANT_ID}`,
		redirectUri: process.env.REACT_APP_MSAL_REDIRECT_URL,
		postLogoutRedirectUri: "/",
		navigateToLoginRequestUrl: false,
	},
	cache: {
		cacheLocation: "localStorage",
		storeAuthStateInCookie: true,
	},
};

export const msalInstance = new PublicClientApplication(configuration);

export async function callMsGraph(msalInstance) {
	const account = msalInstance.getActiveAccount();

	if (!account) {
		throw Error(
			"No active account! Verify a user has been signed in and setActiveAccount has been called.",
		);
	}

	const response = await msalInstance.acquireTokenSilent({
		...loginRequest,
		account: account,
	});

	const headers = new Headers();
	const bearer = `Bearer ${response.accessToken}`;

	headers.append("Authorization", bearer);

	const options = {
		method: "GET",
		headers: headers,
	};

	return fetch(graphConfig.graphMeEndpoint, options)
		.then((response) => response.json())
		.catch((error) => console.log(error));
}
